import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

const MUTATION = gql`
  mutation updateCustomerStatus(
    $site: String!
    $customerId: String!
    $status: String!
  ) {
    updateCustomerStatus(
      site: $site
      customerId: $customerId
      status: $status
    ) {
      id
    }
  }
`;

const useUpdateCustomerStatus = (onCompleted = () => {}) => {
  const [action] = useMutation(MUTATION, { onCompleted });

  return (site: string, customerId: string, status: string) => {
    return action({ variables: { site, customerId, status } });
  };
};

export default useUpdateCustomerStatus;
